import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import RecipeRoundupTeaser from 'components/RecipeRoundupTeaser';

function RecipeRoundup(props) {
  const { id, recipes, subsectionDescription, subsectionTitle } = props;
  if (!recipes) {
    return null;
  }
  return (
    <div className="recipe-roundup-container" data-roundupid={id}>
      {subsectionTitle && (
        <h2
          id={`recipe-roundup--${id}`}
          className="recipe-roundup-subsectionTitle"
          data-roundupid={id}
          dangerouslySetInnerHTML={{ __html: subsectionTitle }}
        />
      )}
      <p dangerouslySetInnerHTML={{ __html: subsectionDescription }} />
      {recipes.map((recipe, index) => (
        <RecipeRoundupTeaser
          key={recipe.url}
          postId={recipe.postIds ? recipe.postIds[0] : null} // Recipes can exist in multiple posts. Get the first id
          roundupStats={{ number: index + 1, roundupTotal: recipes.length }}
          porkchopId={recipe.id}
          title={recipe.title}
          teaserImage={recipe.imageUrl}
          description={recipe.description}
          postUrl={recipe.url}
          imageCredit={recipe.imageCredit}
          isExternal={recipe.isExternal}
        />
      ))}
    </div>
  );
}

RecipeRoundup.propTypes = {
  subsectionTitle: string,
  subsectionDescription: string.isRequired,
  id: string.isRequired,
  recipes: arrayOf(
    shape({
      id: string,
      title: string,
      imageUrl: string,
      description: string,
      url: string
    })
  )
};

RecipeRoundup.defaultProps = {
  subsectionTitle: undefined,
  recipes: undefined
};

export default RecipeRoundup;
